export default () => ({
  display: "inline-block",
  width: "100%",
  margin: "0",
})
